import yup from '../libs/yup'
import { MetadataClass } from '../services/documentTypes.service'
import { Group } from '../services/groups.service'

export type DocumentTypeForm = {
  _id?: string
  name: string
  metadata?: MetadataClass[]
  groups?: Group[]
}

export type ImportDocumentForm = {
  _id?: string
  documentType: string
  metadata?: MetadataClass[]
}

export type DocumentTypeDataForm = {
  _id?: string
  documentType: string
  document: string
  metadata?: MetadataClass[]
}

export const registerDocumentTypeWithDataSchema = yup.object().shape({
  documentType: yup.string().required().label('Name'),
})

export const registerDocumentTypeSchema = yup.object().shape({
  name: yup.string().required().label('Nome do Tipo de Documento'),
})

export const registerMetadata = yup.object().shape({
  name: yup.string().required().label('Name'),
  value: yup.string().label('value'),
})
